import { FormControl } from "@angular/forms";

export class RegularExpressions{

  static readonly ArabicOnly: RegExp = /^[ء-ي\s\-]*$/;   // ^  $ starts and ends , \s space , \- specials character - , * zero ore more
  static readonly EnglishOnly: RegExp = /^[a-zA-Z\s\-]*$/;

  static readonly AllCharactersExceptArabic: RegExp = /^[^ء-ي]*$/;  // ^  $ starts and ends , [^ ] not , * zero ore more
  static readonly AllCharactersExceptEnglish: RegExp = /^[^a-zA-Z]*$/;

  static readonly NumbersOnlyWithTwodecimalPlaces: RegExp = /^((0?\.((0[1-9])|[1-9]\d))|([1-9]\d*(\.\d{2})?))$/;

  static noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

}
